<script lang="ts">let { fill = "white" } = $props();
</script>

<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
	<path
		d="M9.99955 10.9762L14.1244 6.85144L15.3029 8.02995L9.99955 13.3333L4.69629 8.02995L5.8748 6.85144L9.99955 10.9762Z"
		{fill}
	/>
</svg>
